module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjkwMTQgMTguNzAzMUw5LjkwMTM3IDEyLjcwMzFMMTUuOTAxNCA2LjcwMzEyIiBzdHJva2U9IiMzODc1RDMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/chevron-left.svg
// module id = 1013
// module chunks = 38